import { render, staticRenderFns } from "./GroupDevices.vue?vue&type=template&id=6f5232f8&scoped=true&"
import script from "./GroupDevices.vue?vue&type=script&lang=ts&"
export * from "./GroupDevices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5232f8",
  null
  
)

export default component.exports